module.exports = __webpack_public_path__ + "img/josh_dog_walking.4fc6a919.jpg";